import React from "react";
import { Button, useColorModeValue } from "@chakra-ui/react";
import { ButtonProps } from "@chakra-ui/button/dist/types/button";

import { useGetThemeColors } from "ChakraTheme";

interface IProps extends ButtonProps {}

const BlueButton = React.forwardRef<HTMLButtonElement, IProps>(
  ({ children, ...props }, ref) => {
    const colors = useGetThemeColors();
    const backgroundBtnColor = useColorModeValue(
      colors.primary[600],
      colors.gray[100]
    );

    const textColor = useColorModeValue(colors.white, colors.black);

    const hoverBackgroundBtnColor = useColorModeValue(
      colors.primary[700],
      colors.gray[400]
    );
    const activeBackgroundBtnColor = useColorModeValue(
      colors.primary[800],
      colors.gray[800]
    );

    return (
      <Button
        ref={ref}
        color={textColor}
        bg={backgroundBtnColor}
        _hover={{
          bg: hoverBackgroundBtnColor,
        }}
        _active={{
          bg: activeBackgroundBtnColor,
          color: colors.white,
        }}
        {...props}
      >
        {children}
      </Button>
    );
  }
);

export { BlueButton };
